import React, {useEffect, useMemo, useState} from 'react';

import {useParams} from "react-router-dom";
import Loader from "react-loader";
import {NotificationManager} from 'react-notifications';
import { ContractWarningRule } from '../../../../models/ContractWarningRule';
import ContractWarningRuleService from '../../../../services/ContractWarningRuleService';
import ContractWarningRuleForm from '../../../../shared/components/admin/forms/ContractWarningRuleForm';

export default () => {
    const {id = null} = useParams<any>();
    const [loaded, setLoaded] = useState<boolean>(!id)
    const [formData, setFormData] = useState<ContractWarningRule | null>(null)

    useEffect((): void => {
        id && ContractWarningRuleService.client(Number(id)).then(c => {
            c && setFormData(() => c)
            setLoaded(true)
        })
    }, [id])

    const method: (model: ContractWarningRule) => Promise<ContractWarningRule | null> = useMemo(() =>
            id ? ContractWarningRuleService.update : ContractWarningRuleService.store,
        [id, ContractWarningRuleService]
    )

    const handleSubmitForm = (c: ContractWarningRule): void => {
        setFormData(() => c)
        setLoaded(false)
        method(c).then(response => {
                if (response) {
                    NotificationManager.success('Ostrzeżenie zapisane pomyślnie.')
                    window.location.href = '/admin/settings/warningrules'
                } else {
                    NotificationManager.error('Nie udało się zapisać ostrzeżenia.')
                    setLoaded(true)
                }
            }
        )
    }

    return (
        <Loader loaded={loaded}>
            <ContractWarningRuleForm warningRuleData={formData} onSubmitForm={handleSubmitForm}/>
        </Loader>
    )
}